module.exports = __webpack_public_path__ + "static/clever_software-0185145aed331d5cd0575024d69317a0.svg";